'use strict';

var _ = require('lodash');
var RuleVisibilityService = function RuleVisibilityService(configurationService) {
  var visibilityRules = {
    'notEmptyPoses': function notEmptyPoses() {
      return !_.isEmpty(configurationService.getPoses());
    },
    'notEmptyDaPoses': function notEmptyDaPoses() {
      return !_.isEmpty(configurationService.getDaPoses());
    },
    'moreThanOneRecommendationFrequency': function moreThanOneRecommendationFrequency() {
      return configurationService.getRecommendedFrequency() > 1;
    }
  };
  function isRuleVisible(visibilityCondition) {
    return _.isUndefined(visibilityCondition) ? true : visibilityRules[visibilityCondition]();
  }
  return {
    isRuleVisible: isRuleVisible
  };
};
RuleVisibilityService.$inject = ['ConfigurationService'];
module.exports = RuleVisibilityService;